import {
  Component,
  Output,
  EventEmitter,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from '@angular/core';

import { CommonModule, Location } from '@angular/common'; // Asegúrate de importar CommonModule
import { TranslateModule } from '@ngx-translate/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { AlertService } from '../../../core/services/alert/alert.service';
import { OrdersService } from '../../../core/services/orders/orders.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { LocalStorageService } from '../../../core/services/localStorage/local-storage.service';
import { VehicleFormComponent } from './vehicle-form/vehicle-form.component';
import { TabsFormComponent } from './tabs-form/tabs-form.component';
import { GeneralFormComponent } from './general-form/general-form.component';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';
import { AuthStateService } from '../../../core/services/auth-state/auth-state-service.service';
import { CampaignsService } from '../../../core/services/campaigns/campaigns.service';
import { TimelineComponent } from '../timeline/timeline.component';
import { StocksService } from '../../../core/services/stocks/stocks.service';
import { BastidoresTabComponent } from './bastidores-tab/bastidores-tab.component';

interface MatrixData {
  [months: string]: {
    [kms: string]: number;
  };
}

interface Model {
  reference: string;
  name: string;
}
interface VehicleData {
  reference: string;
  model: Model[];
  engine: string;
}
@Component({
  selector: 'app-form-add-stock',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    TranslateModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    NgSelectModule,
    FormsModule,
    GeneralFormComponent,
    VehicleFormComponent,
    TabsFormComponent,
    TimelineComponent,
    BastidoresTabComponent,
  ],

  templateUrl: './form-add-stock.component.html',
  styleUrl: './form-add-stock.component.css'
})
export class FormAddStockComponent {

  @ViewChild(GeneralFormComponent) generalFormComponent?: GeneralFormComponent;
  @ViewChild(VehicleFormComponent) vehicleFormComponent?: VehicleFormComponent;

  @Output() backButtonClick = new EventEmitter<boolean>();

  @Output() addOrder = new EventEmitter<boolean>();
  @Output() formSubmit = new EventEmitter<any>();
  @Input() stockData?: any; // Objeto opcional
  @Input() stockPreData?: any; // Objeto opcional
  @Input() dataContainer?: any;
  @Input() document_buttons_chico = false;
  @Input() ladata: any = [];
  @Input() tab?: any;

  @Input() clientReference!: string;

  showImportantDates = false;
  account_type: any = this.authStateService.getAccountType();
  form: FormGroup = this.fb.group({});
  draft = false;
  stock_reference: string = '';
  /* client_reference: string = ''; */
  client: any = '';
  guarantee_reference: string = '';
  guarantee: any = '';
  back = '';
  brand_id_modal: any;
  searchParams: any = {};
  @Input() client_reference: any;
  @Input() isEditMode: boolean = false;
  showBrokerExcludeTab: boolean = false;
  //viene de la data
  selectTypes: any[] = [];
  newStage: string = '';
  title = '';
  activeForm = 'general';
  posiblesTabs: any[] = [
    'general',
    'notes',
    'doc-order',
    'client',
    'guarantee',
    'risk',
    'timeline',
    'contract',
    'vehicle',
    'delivery',
    'commission',
    'bastidores',
  ];
  clocks: any[] = [];
  docFiles: any[] = [];
  duplicateBrokerContract: any[] = [];
  stage?: any;
  rules: any = {};
  role: any;
  helper = false;
  documentForms: string[] = ['doc-order', 'client', 'guarantee'];

  updatesTabs: any[] = [];
  excludedBrokers: string[] = [];
  helperStep = 1;
  //////////////////////////////////SI///////////////////////////////

  constructor(
    private fb: FormBuilder,
    private alertService: AlertService,
    private orderService: OrdersService,
    private location: Location,
    private stocksService: StocksService,
    private localStorageService: LocalStorageService,
    private router: Router,
    private authStateService: AuthStateService,
  ) { }

  setVariables() {
    this.clocks = this.getClocks(this.stockData?.dates);
    this.duplicateBrokerContract =
      this.stockData?.duplicateBrokerContract || [];
    this.back = this.stockData?.back || '';
    this.stage = this.stockData?.stage;
    this.rules = this.stockData?.rules;
    this.draft = this.stockData ? true : false;
    this.stock_reference = this.stockData?.reference;

    this.client_reference = this.stockData?.client?.reference;
    this.client = this.stockData?.client;
    this.guarantee = this.stockData?.guarantee;
    this.guarantee_reference = this.stockData?.guarantee?.reference;
  }

  getClocks(dates: any): any[] {
    if (dates) {
      this.clocks = Object.entries(this.stockData.dates)
        .filter(([_, value]) => value) // solo fechas no nulas
        .map(([key, value]) => ({
          key,
          value,
        }));
    }
    return this.clocks;
  }
  //////////////////////////////////NO///////////////////////////////

  ngOnChanges(changes: SimpleChanges) {
    this.refrescarFormulario();
    this.role = this.authStateService.getRole();

  }
  time = 120000;

  ngOnInit(): void {
    this.updateBrokerExcludeTabVisibility();
  }

  ngAfterViewInit() {
    this.form = this.fb.group({
      stage: ['draft', Validators.required],
    });
    this.refrescarFormulario();
  }

  onSubmit() {
    const formValues = this.getFormsValues();
    formValues.stage = 'draft';

    this.alertService.loading('swal_messages.please_wait_add_campaign');
    this.stocksService.addData(formValues).subscribe({
      next: (data) => {
        this.alertService
          .success('swal_messages.draft_campaign', 'swal_messages.awesome')
          .then((result) => {
            this.emitAddOrder();
            this.stockData = data.data;
            this.stock_reference = data.data.reference;

            this.isEditMode = true;
            this.excludedBrokers = [];
            this.updateBrokerExcludeTabVisibility();

            this.refrescarFormulario();
          });
      },
      error: (error) => {
        this.alertService.error(error.error).then((result) => {
          if (result.isConfirmed) {
            if (error.code == 409) {
              window.location.reload();
            }
          }
        });
      },
    });
  }

  onSubmitDraft(): void {
    const formValues = this.getFormsValues();

    this.alertService.loading('swal_messages.please_wait_add_order');
    this.stocksService.updateStockData(this.stock_reference, formValues).subscribe({
      next: (data) => {
        this.alertService
          .success('swal_messages.draft_campaign', 'swal_messages.awesome')
          .then((result) => {
            this.emitAddOrder();
            this.stockData = data.data;
            this.isEditMode = true;

            this.refrescarFormulario();
          });
      },
      error: (error) => {
        this.alertService.error(error.error).then((result) => {
          if (result.isConfirmed) {
            if (error.code == 409) {
              window.location.reload();
            }
          }
        });
      },
    });

    this.refrescarFormulario();
  }

  onSubmitOrderFast(stage: string): void {
    const originalOrder = this.stockData;
    const formValues = this.getFormsValues();
    const modifiedFields: any = {};

    formValues['stage'] = stage;
    for (const key in formValues) {
      if (
        formValues.hasOwnProperty(key) &&
        formValues[key] !== originalOrder[key] &&
        formValues[key] !== null &&
        formValues[key] !== 'NaN' &&
        !Number.isNaN(formValues[key])

      ) {
        modifiedFields[key] = formValues[key];
      }
    }

    if (Object.keys(modifiedFields).length === 0) {
      this.alertService.warning('swal_messages.no_changes_made');
      return;
    }


    this.alertService.loading('swal_messages.updating_campaign');
    this.orderService
      .updateData(this.stockData.reference, modifiedFields)
      .subscribe({
        next: (data) => {
          this.alertService
            .successOk('swal_messages.campaign_updated')
            .then((result) => {
              if (result.isConfirmed) {
                this.stockData = data.data;
                this.generalFormComponent?.generalForm.patchValue({
                  notes: '',
                });
                this.updatesTabs = [];
                this.refrescarFormulario();
                this.emitAddOrder();
              }
            });
        },
        error: (error) => {
          this.alertService.error(error.error).then((result) => {
            if (result.isConfirmed) {
              if (error.code == 409) {
                window.location.reload();
              }
            }
          });

        },
      });

    this.refrescarFormulario();
  }

  onSubmitOrder(): void {
    let originalOrder = { ...this.stockData, ...this.stockData.pff };

    const formValues = this.getFormsValues();
    const modifiedFields: any = {};

    for (const key in formValues) {
      if (
        formValues.hasOwnProperty(key) &&
        formValues[key] !== originalOrder[key] &&
        formValues[key] !== null &&
        formValues[key] !== 'NaN' &&
        !Number.isNaN(formValues[key])
      ) {
        modifiedFields[key] = formValues[key];
      }
    }

    if (Object.keys(modifiedFields).length === 0) {
      // Si no hay campos modificados, no hay nada que enviar
      this.alertService.warning('swal_messages.no_changes_made');
      return;
    }
    this.alertService.loading('swal_messages.updating_order');
    this.orderService
      .updateData(this.stockData.reference, modifiedFields)
      .subscribe({
        next: (data) => {
          // Mostrar un mensaje de éxito cuando se actualice correctamente el pedido
          this.alertService
            .successOk('swal_messages.order_updated')
            .then((result) => {
              if (result.isConfirmed) {
                this.stockData = data.data;
                this.updatesTabs = [];
                this.refrescarFormulario();
                this.emitAddOrder();
              }
            });
        },
        error: (error) => {

          this.alertService.error(error.error).then((result) => {
            if (result.isConfirmed) {
              if (error.code == 409) {
                window.location.reload();
              }
            }
          });
        },
      });
  }
  stringToArray(original: string): string[] {
    return original
      .split(',')
      .map(item => item.trim());
  }

  getFormsValues(): any {
    const generalFormValues = this.generalFormComponent?.generalForm.getRawValue();
    const vehicleFormValues = this.vehicleFormComponent?.vehicleForm.getRawValue();

    this.generalFormComponent?.generalForm.get('notes')?.setValue('');
    const formValues = {
      ...this.form.value,
      ...generalFormValues,
      ...vehicleFormValues,
    };

    // Remove null/undefined to avoid sending empty disabled fields that trigger backend validation
    for (const key of Object.keys(formValues)) {
      if (formValues[key] === null || formValues[key] === undefined) {
        delete formValues[key];
      }
    }

    return formValues;
  }
  pristineForms(): any {
    this.generalFormComponent?.generalForm.markAsPristine();
    this.vehicleFormComponent?.vehicleForm.markAsPristine();
  }

  setTitle() {
    this.title = this.stockData?.campaign_stock_reference
      ? this.stockData?.campaign_stock_reference +
      ' ' +
      (this.stockData?.lastname
        ? this.stockData?.lastname
        : '')
      : this.account_type === 'broker'
        ? this.stockData?.broker_reference
        : this.account_type === 'supplier'
          ? this.stockData?.supplier_reference
            ? this.stockData?.supplier_reference
            : this.stockData?.reference
          : this.stockData?.reference;
  }

  refrescarFormulario() {
    this.setVariables();
    this.setTitle();
    if (this.posiblesTabs.includes(this.tab)) {
      if (this.activeForm != this.tab) {
        this.activeForm = this.tab;
      }
    }
    this.pristineForms();
    this.alertService.close();
  }

  checkUpdateForm(form: string) {
    var result: any = false;
    switch (form) {
      case 'general':
        result = this.generalFormComponent?.checkUpdateForm();
        break;
      case 'vehicle':
        result = this.vehicleFormComponent?.checkUpdateForm();
        break;
    }
    if (result) {
      if (!this.updatesTabs.includes(form)) {
        this.updatesTabs.push(form);
      }
    }
  }

  goDocs() {
    this.activeForm = 'doc-order';
  }

  changeForm(form: string) {
    this.activeForm = form;
    this.checkUpdateForm(this.activeForm);
    this.tab = this.activeForm;
  }

  @Input() openedFromClients = false;
  @Output() closeOrderForm = new EventEmitter<void>();

  emitBackButtonClick() {
    //funcion de borrar vista
    this.closeView();

    this.resetFieldDisabled();
    this.draft = false;
    this.stockData = null;
    this.stock_reference = '';
    this.client_reference = '';
    this.guarantee_reference = '';
    this.activeForm = 'general';
    this.backButtonClick.emit(true);
  }

  emitAddOrder() {
    this.addOrder.emit(true);
  }

  resetFieldDisabled() {
    for (const field in this.form.controls) {
      if (this.form.controls.hasOwnProperty(field)) {
        this.form.get(field)?.enable();
      }
    }
  }

  actualizarEstadoArchivos(nuevoArrayArchivos: any[]) {
    this.docFiles = nuevoArrayArchivos;
  }

  refrescar() {
    this.alertService.loading('swal_messages.please_wait');
    this.orderService.getDataByReference(this.stockData.reference).subscribe({
      next: (data) => {
        this.stockData = data.data;
        this.refrescarFormulario();
        this.alertService.close();
      },
      error: (error) => {
        this.alertService.error(error.error).then((result) => {
          if (result.isConfirmed) {
          }
        });
      },
    });
  }

  isDocumentForm(): boolean {
    return this.documentForms.includes(this.activeForm);
  }

  refrescarOrder(stockData: any) {
    this.stockData = stockData;
    this.setVariables();
  }

  //DUPLICATE ORDER
  duplicateOrder() {
    this.alertService
      .confirmation(
        'swal_messages.duplicate_order_title',
        'swal_messages.duplicate_order_message',
        'swal_messages.confirm',
        'swal_messages.back'
      )
      .then((result) => {
        if (result.isConfirmed) {
          this.alertService.loading('swal_messages.please_wait');
          this.orderService.duplicateOrder(this.stock_reference).subscribe({
            next: (data) => {
              this.alertService
                .successOk('swal_messages.duplicate_order_success')
                .then((result) => {
                  if (result.isConfirmed) {
                    this.stockData = data.data;
                    this.updatesTabs = [];
                    this.refrescarFormulario();
                    this.emitAddOrder();
                  }
                });
            },
            error: (error) => {
              this.alertService.error('swal_messages.order_not_found');
            },
          });
        } else {
        }
      });
  }


  //PASA MANOS DE EVENTOS//
  @Output() emitOpenAssigneeForm = new EventEmitter<boolean>();
  @Output() emitOpenAssigneeCreateForm = new EventEmitter<boolean>();
  @Output() emitCloseClientForm = new EventEmitter<boolean>();
  @Output() emitCloseAssigneeForm = new EventEmitter<boolean>();
  @Output() emitOpenClientForm = new EventEmitter<string>();
  @Output() emitOpenAddressesForm = new EventEmitter<boolean>();
  @Output() emitCloseAddressesForm = new EventEmitter<boolean>();

  openAssigneeForm(assignee: any) {
    this.document_buttons_chico = true;
    this.emitOpenAssigneeForm.emit(assignee);
  }

  openClientForm(optAdd: string) {
    this.document_buttons_chico = true;
    this.emitOpenClientForm.emit(optAdd);
  }

  openAssigneeCreateForm() {
    this.document_buttons_chico = true;
    this.emitOpenAssigneeForm.emit(true);
  }

  openAddressesForm() {
    this.document_buttons_chico = true;
    this.emitOpenAddressesForm.emit(true);
  }

  //NOTAS
  activeNotesTab: string = 'public';

  onTabChanged(tab: string) {
    this.activeNotesTab = tab;
  }

  closeView() {
    this.orderService.closeView(this.stock_reference).subscribe({
      next: (data) => {
      },
      error: (error) => {
        // this.alertService.error('swal_messages.order_not_found');
      }
    });
  }

  closeViewOverlay() {
    this.orderService.closeView(this.stock_reference).subscribe({
      next: (data) => {
      },
      error: (error) => {
        // this.alertService.error('swal_messages.order_not_found');
      }
    });

    this.draft = false;
    this.stockData = null;
    this.stock_reference = '';
    this.client_reference = '';
    this.guarantee_reference = '';
    this.activeForm = 'general';
  }

  goContract(url: string) {
    const nuevaURL = url;
    this.router.navigate([url]);
  }

  updateView() {
    this.orderService.updateView(this.stock_reference).subscribe({
      next: (data) => {

        this.duplicateBrokerContract = data.data.duplicateBrokerContract;
      },
      error: (error) => {
        // this.alertService.error('swal_messages.order_not_found');
      }
    });
  }

  private updateBrokerExcludeTabVisibility(): void {
    if (this.isEditMode) {
      this.showBrokerExcludeTab = !this.stockData?.broker_id;
    } else {
      this.showBrokerExcludeTab = true;
    }
  }

  hasExcludedBrokers: boolean = false;

  onExcludedBrokersChanged(brokers: string[]): void {
    this.excludedBrokers = brokers;
    this.hasExcludedBrokers = brokers.length > 0;
  }

  onBrokerSelected(brokerId: string): void {
    const hadBrokerExcluded = this.excludedBrokers.length > 0;

    if (brokerId && brokerId !== '') {
      this.showBrokerExcludeTab = false;

      if (hadBrokerExcluded) {
        this.excludedBrokers = [];
        this.hasExcludedBrokers = false;

      }

      if (this.activeForm === 'broker_exclude') {
        this.activeForm = 'general';
      }
    } else {
      this.showBrokerExcludeTab = true;
    }
  }

}
